import React from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import MaskedInput from "react-maskedinput";
import { FormikProps } from "formik";
import { SimulatorTextField } from "../fields/SimulatorTextField";
import { SimulatorSelectField } from "../fields/SimulatorSelectField";
import { Distribuidora, FormValues, SimulationHistoryItem } from "../types";

interface ClientDataSectionProps {
  formik: FormikProps<FormValues>;
  distribuidoras: Distribuidora[];
  clientHistory: SimulationHistoryItem[];
  internalPartnerPermission: boolean;
  onShowHistory: () => void;
  resetGrupoTarifario: (e: any) => void;
  resetTHSWithGrupoTarifario: (e: any) => void;
  resetTHS: (e: any) => void;
}

export const ClientDataSection = ({
  formik,
  distribuidoras,
  clientHistory,
  internalPartnerPermission,
  onShowHistory,
  resetGrupoTarifario,
  resetTHSWithGrupoTarifario,
  resetTHS,
}: ClientDataSectionProps) => (
  <>
    <div>
      <span className="simulacao-form-header">Dados do cliente</span>
      <hr />
    </div>

    <div className="formLine">
      <Form.Group
        controlId="simulationCNPJ"
        style={{ width: "100%", maxWidth: "375px", height: "80px" }}
      >
        <Form.Label
          className="simulacao-form-title"
          style={{ display: "flex", flexDirection: "row", gap: "8px" }}
        >
          CNPJ da Empresa <span>*</span>
          {clientHistory.length > 0 && internalPartnerPermission && (
            <div
              onClick={() => {
                onShowHistory();
              }}
            >
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-disabled">
                    Foram encontrados {clientHistory.length} estudos para esse
                    cliente
                  </Tooltip>
                }
              >
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    borderRadius: "100%",
                    backgroundColor: "#cece00",
                    display: "flex",
                    color: "white",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "12px",
                  }}
                >
                  !
                </div>
              </OverlayTrigger>
            </div>
          )}
        </Form.Label>
        <Form.Control
          name="cnpj"
          placeholder="00.000.000/0000-00"
          as={MaskedInput}
          mask="##.###.###/####-11"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.cnpj}
          isInvalid={!!formik.touched.cnpj && !!formik.errors.cnpj}
          required
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.cnpj}
        </Form.Control.Feedback>
      </Form.Group>

      <SimulatorTextField
        formik={formik}
        name="nomeCliente"
        label="Nome do cliente"
        placeholder="Sigla ou por extenso"
      />

      <SimulatorTextField
        formik={formik}
        name="custoGestao"
        placeholder="Em reais"
        prefix="R$"
        labelStyle={{ display: "flex", flexDirection: "row", gap: "8px" }}
        label={
          <>
            Custo Operacional e CCEE{" "}
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-disabled">
                  O custo será calculado automaticamente caso nenhum valor seja
                  enviado.
                </Tooltip>
              }
            >
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "100%",
                  backgroundColor: "#0072ce",
                  display: "flex",
                  color: "white",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                }}
              >
                ?
              </div>
            </OverlayTrigger>
          </>
        }
      />
    </div>

    <div className="formLine">
      <SimulatorSelectField
        formik={formik}
        name="distribuidora"
        controlId="simulationCNPJ"
        label={
          <>
            Distribuidora <span>*</span>
          </>
        }
        onChange={(e: any) => resetGrupoTarifario(e)}
        showError
      >
        <option key="" hidden>
          Selecione a distribuidora
        </option>

        {distribuidoras.map((d) => (
          <option key={d.id} value={d.value}>
            {d.name}
          </option>
        ))}
      </SimulatorSelectField>

      <SimulatorSelectField
        formik={formik}
        name="grupoTarifario"
        label={
          <>
            Grupo Tarifário <span>*</span>
          </>
        }
        onChange={(e: any) => resetTHSWithGrupoTarifario(e)}
        disabled={!!!formik.values.distribuidora}
        showError
      >
        <option value="" hidden>
          Selecione uma opção
        </option>

        {distribuidoras.map(
          (d) =>
            d.name === formik.values.distribuidora &&
            d.tarifas.map((t: string) => (
              <option key={d.id + t} value={t}>
                {t}
              </option>
            ))
        )}
      </SimulatorSelectField>

      <SimulatorSelectField
        formik={formik}
        name="ths"
        controlId="simulationNumber"
        label={
          <>
            THS <span>*</span>
          </>
        }
        onChange={(e: any) => resetTHS(e)}
      >
        <option value="VERDE" disabled={formik.values.grupoTarifario === "A3"}>
          Verde
        </option>
        <option value="AZUL">Azul</option>
      </SimulatorSelectField>
    </div>
  </>
);
